import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { UserForBackend } from '../user-for-backend';
import { Role } from '../role';
import { Router } from '@angular/router';
import { ROLES } from '../roles';
import { MessageService } from 'primeng/api';
import { SalesAgent } from '../sales-agent';

@Component({
  selector: 'app-system-user-create',
  templateUrl: './system-user-create.component.html',
  styleUrls: ['./system-user-create.component.css']
})
export class SystemUserCreateComponent implements OnInit {

  userForm: FormGroup | undefined;
  roles: string[] = ROLES;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private favicon: FaviconService,
    private loginService: LoginService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }



  ngOnInit() {
    this.userForm = this.builder.group({
      username: ["", Validators.required],
      password: ["", Validators.pattern(new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"))],
      email: ["", Validators.required],
      slackId: "",
      roles: this.builder.array([])
    });
    this.setRoles();
  }

  sendForm() {
    let user = new UserForBackend(
      this.userForm!.value.username,
      this.userForm!.value.email,
      this.userForm!.value.password,
      this.getCheckedRoles(),
      false,
      this.userForm!.value.slackId,
      null,
      true
    );
    this.httpService.postSystemUser(user).subscribe(() =>{
      console.log("success");
      this.router.navigateByUrl("/management/users");
    }, error => {
      this.addError("Error: ", error.message);
    });
  }

  setRoles(){
    for(let role of this.roles){
      (this.userForm!.controls["roles"] as FormArray).push(new FormControl(false));
    }
  }

  getCheckedRoles(){
    let newRoles: string[] = [];
    for(let j = 0; j < (this.userForm!.controls["roles"] as FormArray).length; j++){
      if((this.userForm!.controls["roles"] as FormArray).controls[j].value == true){
        newRoles.push(this.roles[j]);
      }
    }
    return newRoles;
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

}
